import * as http from '@utils/baseRequest';
import {host} from '@utils/hostConf';

export function receiveCoupon(data) {
  return http.post({
    url: host.cplus + 'cgi-bin/coupon/receivecoupon',
    data,
  });
}

export function fetchQuestionnaireCouponList(data) {
  return http.get({
    url: host.goapi + 'datasync/handler/QueryTsCoupon',
    data,
  });
}

export function receiveQuestionnaireCoupon(data) {
   return http.post({
    url:`${host.cplus}cgi-bin/coupon/receivecoupon`,
    data,
  });
}
//筛选优惠券
export function reqFilterCouponList(data) {
  return http.post({url: `${host.cplus}cgi-bin/coupon/filterusercouponlistpost`, data});
}

export function QueryTsCouponRecord(data) {
  return http.get({url: `${host.goapi}datasync/handler/QueryTsCouponRecord`, data});
}
